import React from 'react';

import './AppNavBar.scss';

export interface AppNavBarProps {
  /** Logo `<img>`/`<svg>`. Click → home. */
  brand?: React.ReactNode;
  onBrandClick?: () => void;
  /** Host tracks open state. Omit to hide the hamburger entirely. */
  onMenuToggle?: () => void;
  menuOpen?: boolean;
  /** Search, user pill, notifications, etc. */
  trailing?: React.ReactNode;
  className?: string;
}

/** Glass top nav — translucent navy, backdrop blur, hairline border. NOT from Claude Design. */
export const AppNavBar: React.FC<AppNavBarProps> = ({
  brand,
  onBrandClick,
  onMenuToggle,
  menuOpen,
  trailing,
  className,
}) => (
  <nav className={`wb-nav${className ? ' ' + className : ''}`}>
    <div className="wb-nav__left">
      {onMenuToggle && (
        <button
          type="button"
          className={`wb-nav__menu-btn${menuOpen ? ' is-open' : ''}`}
          onClick={onMenuToggle}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <i className="bi bi-list" aria-hidden />
        </button>
      )}
    </div>
    {brand && (
      <button
        type="button"
        className="wb-nav__brand"
        onClick={onBrandClick}
        aria-label="Home"
      >
        {brand}
      </button>
    )}
    <div className="wb-nav__right">{trailing}</div>
  </nav>
);

export default AppNavBar;
